import { DefaultContainer } from '@/components/DefaultContainer';
import { AssignableTrainingPlan } from '@/generated';
import { planApi } from '@/generated/clients';
import { Assignment, AssignmentAdd, AssignmentReturn } from '@mui/icons-material';
import { CardActions, Grid, IconButton, Paper, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PlanCard } from '../plans/PlanCard';
import { enqueueSnackbar } from 'notistack';
import { useListUserDecksQuery } from '@/hooks/query-hooks';

export const TraineePlanAssignment = () => {
  const { traineeId } = useParams();
  const [assignablePlans, setAssignablePlans] = useState<AssignableTrainingPlan[]>();
  const { decks } = useListUserDecksQuery(true);

  const getPlans = async () => {
    if (traineeId) {
      const assignablePlans = await planApi.planGetAssignablePlansForUser({ userId: traineeId });
      setAssignablePlans(assignablePlans);
    }
  };

  useEffect(() => {
    getPlans();
  }, [traineeId]);

  return (
    <DefaultContainer>
      <Paper sx={{ my: 1, zIndex: 1, padding: 1, position: 'sticky', top: { xs: 60, sm: 65 } }}>
        <Grid sx={{ alignContent: 'center', alignItems: 'center' }} container gap={2} direction={'row'}></Grid>
      </Paper>
      <Grid container direction={'row'} spacing={2}>
        {assignablePlans
          ?.filter((p) => p.userHasDecks || p.viewerIds.includes(traineeId ?? ''))
          .map((p) => (
            <Grid size={{ xs: 12, md: 4 }}>
              <PlanCard decks={decks} timeout={10} plan={p}>
                <CardActions sx={{ justifyContent: 'flex-end', alignSelf: 'flex-end', flex: 0.1 }}>
                  {traineeId && !p.viewerIds.includes(traineeId) && (
                    <>
                      <Tooltip title={`Assign ${p.title} to user`}>
                        <IconButton
                          onClick={async () => {
                            const sendEmail = window.confirm('Send Email?');
                            await planApi.planAssignPlan({ assignPlanToUser: { planId: p.id, targetUserId: traineeId, sendEmail: sendEmail } });
                            getPlans();
                            enqueueSnackbar('Training Plan successfully assigned to user.', { variant: 'success' });
                          }}
                        >
                          <Assignment />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  {traineeId && !p.viewerIds.includes(traineeId) && (
                    <>
                      <Tooltip title={`Assign ${p.title} to user and add user to editors`}>
                        <IconButton
                          onClick={async () => {
                            const sendEmail = window.confirm('Send Email?');
                            await planApi.planAssignPlan({ assignPlanToUser: { addUserToEditors: true, planId: p.id, targetUserId: traineeId, sendEmail: sendEmail } });
                            getPlans();
                            enqueueSnackbar('Training Plan successfully assigned to user.', { variant: 'success' });
                          }}
                        >
                          <AssignmentAdd />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  {traineeId && p.viewerIds.includes(traineeId) && (
                    <>
                      <Tooltip title={`Unassign ${p.title} from user`}>
                        <IconButton
                          onClick={async () => {
                            await planApi.planUnAssignPlan({ assignPlanToUser: { planId: p.id, targetUserId: traineeId } });
                            enqueueSnackbar('Training Plan successfully unassigned from user', { variant: 'success' });
                            getPlans();
                          }}
                        >
                          <AssignmentReturn />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </CardActions>
              </PlanCard>
            </Grid>
          ))}
      </Grid>
    </DefaultContainer>
  );
};
